export class GridFilterCondition {

    constructor(public filteringStr: string = '',
                public assignFilterType: string = 'me',
                public searchValue: string = '',
                public oidx: string = '',
                public currentPage = 1,
                public times: any = {},
                public report: any = {},
                public itemsPerPage = 20 ) {}

}



// WEBPACK FOOTER //
// ./src/app/shared/models/src/gridFilterCondition/grid-filter-condition.ts